<template>
  <v-list-item v-bind="$attrs" @click="logout">
    <v-list-item-title>
      <v-icon left>mdi-logout</v-icon>Logout
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { onLogout } from '@/vue-apollo'
import { logout } from '@/graphql/auth.gql'

export default {
  name: 'AuthLogoutMenuItem',
  inheritAttrs: true,
  methods: {
    logout() {
      this.$apollo
        .mutate({
          mutation: logout
        })
        .then(data => {
          onLogout(this.$apollo.provider.defaultClient)

          this.$nextTick(() => {
            this.$store.commit('auth/SET_CURRENT_USER', null)
          })

          // this.$router.go() TODO - Fix logout redirect when in admin
        })
        .catch(error => {
          this.handleGraphQLErrors(error)

          // this.$router.go() TODO - Fix logout redirect when in admin
        })
    }
  }
}
</script>
